import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  /** Optional sub-content below the value */
  detail?: ReactNode;
  /** Color class for the value text */
  valueColor?: string;
  className?: string;
}

export function StatCard({ label, value, detail, valueColor = 'text-white', className = '' }: StatCardProps) {
  return (
    <div className={`bg-navy-900 border border-navy-700 rounded-xl p-4 ${className}`}>
      <div className={`text-2xl font-bold ${valueColor}`}>{value}</div>
      <div className="text-xs text-slate-400">{label}</div>
      {detail && <div className="mt-2">{detail}</div>}
    </div>
  );
}
